<template>
  <div class="print-question-answer-detail-container">
    <el-row :gutter="20">
      <el-col :span="4" id="print-room">
        <el-card class="tree-card">
          <ul class="room-list">
            <li v-for="(item, index) in printQuestionAnswerDetailInfo.userQuestions" :key="index"
              @click="swatchRoom(item)" :class="{ 'selected-room': printQuestionAnswerDetailInfo.roomId == item.roomId }">
              <span :class="item.state === '1202' ? 'voted-tag' : 'unvoted-tag'">
                {{ item.state === '1202' ? '已投' : '未投' }}
              </span>
              {{ item.roomName }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="20">
        <div class="text-center">
          <h1>{{ printQuestionAnswerDetailInfo.qaName }}</h1>
        </div>
        <!-- 题目简介和用户信息JSON已移除 -->

        <div id="print-btn" class="margin-top margin-bottom">
          <el-button type="success" size="small" @click="_exportExcel">
            <i class="el-icon-download"></i>&nbsp;导出 Excel
          </el-button>
          <el-button type="primary" size="small" @click="_printPurchaseApplyDiv">
            <i class="el-icon-printer"></i>&nbsp;{{ $t('printQuestionAnswerDetail.print') }}
          </el-button>
          <el-button type="warning" size="small" @click="_closePage">
            <i class="el-icon-close"></i>
            {{ $t('printQuestionAnswerDetail.cancel') }}
          </el-button>
        </div>

        <el-table :data="printQuestionAnswerDetailInfo.questionTitles" border style="width: 100%" class="margin-top">
          <el-table-column prop="qaTitle" :label="$t('printQuestionAnswerDetail.table.title')" width="300" align="center">
            <template slot-scope="scope">
              <div style="max-width: 300px;">
                {{ scope.row.qaTitle }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="titleType" :label="$t('printQuestionAnswerDetail.table.type')" width="300"
            align="center">
            <template slot-scope="scope">
              {{ _getTitleTypeName(scope.row.titleType) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('printQuestionAnswerDetail.table.options')" align="center">
            <template slot-scope="scope">
              <div v-for="(item, index) in scope.row.titleValues" :key="index">
                {{ item.seq }}、{{ item.qaValue }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('printQuestionAnswerDetail.table.choices')" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.titleType === '3003'">
                {{ _getShortAnswer(scope.row.titleId) }}
              </div>
              <div v-else v-for="(item, index) in scope.row.titleValues" :key="index">
                {{ _getChooseValue(item) }}
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="margin-top">
          <span>{{ $t('printQuestionAnswerDetail.total') }}：{{ printQuestionAnswerDetailInfo.voteCount }}</span>；
          <span>{{ $t('printQuestionAnswerDetail.submitted') }}：{{ printQuestionAnswerDetailInfo.votedCount }}</span>；
          <span v-for="(item, tIndex) in printQuestionAnswerDetailInfo.titleValues" :key="tIndex">
            {{ item.qaValue }}: {{ item.personCount }}{{ $t('printQuestionAnswerDetail.people') }}；
          </span>
        </div>

        <div class="text-right margin-top">
          {{ currentCommunity.name }}
        </div>
        <div class="text-right margin-top-sm">
          {{ currentDate }}
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { getCommunityId ,getCommunity} from '@/api/community/communityApi'
import {
  listQuestionAnswer,
  listQuestionTitle,
  listUserQuestionAnswer
} from '@/api/oa/printQuestionAnswerDetailApi'

export default {
  name: 'PrintQuestionAnswerDetailList',
  data() {
    return {
      printQuestionAnswerDetailInfo: {
        qaName: '',
        startTime: '',
        endTime: '',
        communityId: '',
        content: '',
        titleType: '',
        questionTitles: [],
        updateRoomIds: false,
        voteCount: 0,
        qaId: '',
        votedCount: 0,
        userQuestions: [],
        roomId: '',
        userQuestion: {}
      },
      currentCommunity: {},
      currentDate: new Date().toLocaleDateString()
    }
  },
  created() {
    this.printQuestionAnswerDetailInfo.communityId = getCommunityId()
    this.currentCommunity = getCommunity()
    this.printQuestionAnswerDetailInfo.qaId = this.$route.query.qaId
    this._listValues()
  },
  methods: {
    async _listQuestionAnswers() {
      try {
        const params = {
          page: 1,
          row: 1,
          communityId: this.printQuestionAnswerDetailInfo.communityId,
          qaId: this.printQuestionAnswerDetailInfo.qaId
        }
        const { data } = await listQuestionAnswer(params)
        console.log(data, 'data')
        Object.assign(this.printQuestionAnswerDetailInfo, data[0])
      } catch (error) {
        console.error('Failed to load question answers:', error)
      }
    },
    async _loadQuestionTitles() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.printQuestionAnswerDetailInfo.communityId,
          qaId: this.printQuestionAnswerDetailInfo.qaId
        }
        const { data } = await listQuestionTitle(params)
        console.log(data, 'data')
        this.printQuestionAnswerDetailInfo.questionTitles = data
      } catch (error) {
        console.error('Failed to load question titles:', error)
      }
    },
    _printPurchaseApplyDiv() {
      this.printFlag = '1'
      document.getElementById("print-btn").style.display = "none"
      document.getElementById("print-room").style.display = "none"
      window.print()
      window.opener = null
      window.close()
    },
    _closePage() {
      window.opener = null
      window.close()
    },
    _exportExcel() {
      const titles = this.printQuestionAnswerDetailInfo.questionTitles
      const votedUsers = this.printQuestionAnswerDetailInfo.userQuestions.filter(u => u.state === '1202')
      if (votedUsers.length === 0) {
        this.$message.warning('没有已投票的记录')
        return
      }
      // 构建表头
      let html = '<table border="1">'
      html += '<tr><th>房号</th><th>投票状态</th>'
      for (let t of titles) {
        html += '<th>' + t.qaTitle + '</th>'
      }
      html += '</tr>'
      // 构建数据行
      for (let user of votedUsers) {
        html += '<tr>'
        html += '<td>' + (user.roomName || '') + '</td>'
        html += '<td>已投票</td>'
        for (let t of titles) {
          let answer = ''
          if (t.titleType === '3003') {
            // 简答
            if (user.values) {
              for (let v of user.values) {
                if (v.titleId === t.titleId) {
                  answer = v.qaValue || v.valueContent || ''
                  break
                }
              }
            }
          } else {
            // 单选/多选
            if (user.values && t.titleValues) {
              let selected = []
              for (let tv of t.titleValues) {
                for (let uv of user.values) {
                  if (uv.qaValue === tv.qaValue) {
                    selected.push(tv.seq + '.' + tv.qaValue)
                  }
                }
              }
              answer = selected.join('；')
            }
          }
          html += '<td>' + answer + '</td>'
        }
        html += '</tr>'
      }
      html += '</table>'
      // 下载
      const blob = new Blob(['﻿' + html], { type: 'application/vnd.ms-excel' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = (this.printQuestionAnswerDetailInfo.qaName || '投票明细') + '.xls'
      a.click()
      URL.revokeObjectURL(url)
      this.$message.success('导出成功，共 ' + votedUsers.length + ' 条记录')
    },
    _getTitleTypeName(_titleType) {
      if (_titleType === '1001') {
        return this.$t('printQuestionAnswerDetail.singleChoice')
      } else if (_titleType === '2002') {
        return this.$t('printQuestionAnswerDetail.multipleChoice')
      } else {
        return this.$t('printQuestionAnswerDetail.shortAnswer')
      }
    },
    swatchRoom(_room) {
      console.log(_room, 'swatchRoom')
      this.printQuestionAnswerDetailInfo.roomId = _room.roomId
      this.printQuestionAnswerDetailInfo.userQuestion = _room
    },
    async _listValues() {
      try {
        const params = {
          page: 1,
          row: 1000000,
          communityId: this.printQuestionAnswerDetailInfo.communityId,
          qaId: this.printQuestionAnswerDetailInfo.qaId
        }
        const { data } = await listUserQuestionAnswer(params)
        // 按投票状态排序：已投(1202)靠前，未投(1201)靠后
        data.sort((a, b) => {
          if (a.state === '1202' && b.state !== '1202') return -1
          if (a.state !== '1202' && b.state === '1202') return 1
          return 0
        })
        this.printQuestionAnswerDetailInfo.userQuestions = data
        console.log(this.printQuestionAnswerDetailInfo.userQuestions, 'userQuestions')
        await this._listQuestionAnswers()
        await this._loadQuestionTitles()
        if (data && data.length > 0) {
          this.swatchRoom(data[0])
        }
      } catch (error) {
        console.error('Failed to load user question answers:', error)
      }
    },
    _getChooseValue(_title) {
      const _userQuestion = this.printQuestionAnswerDetailInfo.userQuestion
      let _chooseValue = 'X'
      if (_userQuestion['values']) {
        _userQuestion.values.forEach(tmpValue => {
          if (tmpValue.qaValue === _title.qaValue) {
            _chooseValue = 'V'
          }
        })
      }
      return _chooseValue
    },
    _getShortAnswer(_titleId) {
      const _userQuestion = this.printQuestionAnswerDetailInfo.userQuestion
      if (_userQuestion && _userQuestion.values) {
        for (let val of _userQuestion.values) {
          if (val.titleId === _titleId) {
            return val.qaValue || val.valueContent || ''
          }
        }
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.print-question-answer-detail-container {
  padding: 20px;

  .tree-card {
    height: 100%;

    .room-list {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        padding: 10px;
        margin-bottom: 5px;
        cursor: pointer;
        border-radius: 4px;
        text-align: center;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;

        &:hover {
          background-color: #f5f7fa;
        }

        &.selected-room {
          background-color: #409eff;
          color: white;
        }
      }

      .voted-tag {
        font-size: 10px;
        padding: 1px 5px;
        border-radius: 3px;
        color: #fff;
        background-color: #67c23a;
        flex-shrink: 0;
      }

      .unvoted-tag {
        font-size: 10px;
        padding: 1px 5px;
        border-radius: 3px;
        color: #fff;
        background-color: #f56c6c;
        flex-shrink: 0;
      }
    }
  }

  .margin-top {
    margin-top: 20px;
  }

  .margin-top-sm {
    margin-top: 10px;
  }

  .margin-right {
    margin-right: 20px;
  }

  .float-right {
    float: right;
  }

  .text-center {
    text-align: center;
  }

  .text-right {
    text-align: right;
  }
}

#print-btn,
#print-room {
  @media print {
    display: none !important;
  }
}
</style>